<template>
  <v-col>
    <v-col>
      <v-expansion-panels
        focusable
        hover
      >
        <!-- Sale Slips -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            Sale Slips
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <sale-slips />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- end -->

        <!-- Refund Slips -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            Sale Refund Slips
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <refund-slips />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- end -->

        <!-- Refund Slips -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            Purchase Slips
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <purchase-slips />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- end -->

        <!-- Repair Slips -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            Repair Slips
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <repair-slips />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- end -->

        <!-- Repair Slips -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            Buy Form Customer Slips
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <custom-slips />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- end -->

        <!-- Repair Slips -->
        <v-expansion-panel>
          <v-expansion-panel-header>
            Bill Slips
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <bill-slips />
          </v-expansion-panel-content>
        </v-expansion-panel>
        <!-- end -->
      </v-expansion-panels>
    </v-col>
    <p>
      <strong>Note : </strong> All terms and conditions lines need to be
      separated by comma (,) while adding or updating.
    </p>
    <small><strong>Example : </strong> Term and condition line 1, Term and condition
      line 2, Term and condition line 3</small>
  </v-col>
</template>
<script>
import SaleSlips from "../terms/SaleSlips.vue";
import RefundSlips from "../terms/RefundSlips.vue";
import PurchaseSlips from "../terms/PurchaseSlips.vue";
import RepairSlips from "../terms/RepairSlips.vue";
import CustomSlips from "../terms/BuyFromCustomerSlips.vue";
import BillSlips from "../terms/BillSlips.vue";
export default {
  components: {
    "sale-slips": SaleSlips,
    "refund-slips": RefundSlips,
    "purchase-slips": PurchaseSlips,
    "repair-slips": RepairSlips,
    "custom-slips": CustomSlips,
    "bill-slips": BillSlips,
  },
};
</script>
